<template>
  <!-- 输入框、文本域 输入文字数量设置
       @author: 王汝鹏
       @date: 2019-9-25
   -->
  <div class="setting-item">
    <el-form-item label="最大输入长度"> 
        <el-input type="text" 
                  v-model.number="textLength"
                  placeholder="请输入最大输入长度">
        </el-input> 
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 最大输入文本长度
     *  @description 将 textLength 字段映射到当前 textLength 计算属性
     *  @return { Object }
     *  @author 王汝鹏
     *  @version 2019-09-25
     */
    ...mapComputed({
      textLength: { 
        parent: i => i.baseOption,
        attr: "textLength",
        setFormat: (value) => { return value || undefined; }
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingTextLength.vue